module.exports = __webpack_public_path__ + "8c7785a2ef33b81024d2be58e1734a74.png";